import { render, staticRenderFns } from "./AcceptInvite.vue?vue&type=template&id=716b4a3c&scoped=true"
import script from "./AcceptInvite.vue?vue&type=script&lang=js"
export * from "./AcceptInvite.vue?vue&type=script&lang=js"
import style0 from "./AcceptInvite.vue?vue&type=style&index=0&id=716b4a3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716b4a3c",
  null
  
)

export default component.exports